// extracted by mini-css-extract-plugin
export default {"bidAskButton":"askBidGroupButton_bidAskButton__oSlg7","ask":"askBidGroupButton_ask__JyA8n","bid":"askBidGroupButton_bid__HYMbw"};